/* Northern Raised advertorial template behaviours. Loaded only on page.advertorial-* templates. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.adv');
  if (!root) return;

  /* page-load reveal */
  requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('adv-is-ready'); }); });

  /* reading progress + sticky CTA */
  var bar = document.getElementById('adv-progress');
  var sticky = document.getElementById('adv-sticky');
  var capture = document.querySelector('.adv-capture');
  var showAt = sticky ? parseFloat(sticky.dataset.showAt || '18') / 100 : 0.18;
  var hideOnCapture = sticky ? sticky.dataset.hideOnCapture === 'true' : true;
  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var p = max > 0 ? h.scrollTop / max : 0;
    if (bar) bar.style.width = (p * 100) + '%';
    if (sticky) {
      var capOn = false;
      if (capture && hideOnCapture) { var r = capture.getBoundingClientRect(); capOn = r.top < h.clientHeight && r.bottom > 0; }
      sticky.classList.toggle('adv-show', p > showAt && !capOn);
    }
  }
  document.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* reveal on scroll, cards only */
  var rv = root.querySelectorAll('.adv-rv');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('adv-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('adv-in'); }); }

  /* label decoder tabs */
  root.querySelectorAll('.adv-decoder').forEach(function (dec) {
    var tabs = dec.querySelectorAll('.adv-tab');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        dec.querySelectorAll('.adv-panel').forEach(function (p) { p.removeAttribute('data-active'); });
        var panel = dec.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.setAttribute('data-active', '');
        t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  });

  /* email capture: Klaviyo client API, falls back to Shopify customer form post */
  root.querySelectorAll('.adv-capture').forEach(function (cap) {
    var form = cap.querySelector('form[data-klaviyo]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button');
      if (!inp.value || inp.value.indexOf('@') < 0) { inp.focus(); inp.style.borderColor = '#f56852'; return; }
      var company = form.dataset.company, list = form.dataset.list;
      btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'One sec';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source || 'Advertorial page',
              profile: { data: { type: 'profile', attributes: { email: inp.value, properties: { advertorial: form.dataset.source || '' } } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          cap.classList.add('adv-is-done');
          if (window.dataLayer) window.dataLayer.push({ event: 'advertorial_email_signup', source: form.dataset.source || '' });
          if (window.fbq) window.fbq('track', 'Lead', { content_name: form.dataset.source || 'advertorial' });
          if (window._tfa) window._tfa.push({ notify: 'event', name: 'email_signup', id: form.dataset.taboola || undefined });
        } else { throw new Error('klaviyo'); }
      }).catch(function () {
        btn.disabled = false; btn.textContent = btn.dataset.label;
        cap.querySelector('.adv-err').hidden = false;
      });
    });
  });

  /* product carousel dots */
  root.querySelectorAll('.adv-shelf-track').forEach(function (shelf) {
    var dots = shelf.parentElement.querySelector('.adv-dots');
    var tiles = shelf.querySelectorAll('.adv-tile');
    if (!dots || !tiles.length) return;
    tiles.forEach(function () { dots.appendChild(document.createElement('i')); });
    function upd() {
      var idx = Math.round(shelf.scrollLeft / (tiles[0].offsetWidth + 12));
      dots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('adv-on', i === idx); });
    }
    shelf.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* quick add: posts to /cart/add.js, then tries to open the theme cart drawer */
  root.querySelectorAll('.adv-add[data-variant]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = b.dataset.variant; if (!id) return;
      var sectionsParam = document.querySelector('cart-drawer') ? '&sections=cart-drawer,cart-icon-bubble' : '';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: sectionsParam ? ['cart-drawer', 'cart-icon-bubble'] : undefined })
      }).then(function (r) { return r.json(); }).then(function (res) {
        b.textContent = '✓'; b.style.background = '#f56852';
        setTimeout(function () { b.textContent = '+'; b.style.background = ''; }, 1400);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else if (drawer && typeof drawer.open === 'function') { drawer.open(); }
        if (window.fbq) window.fbq('track', 'AddToCart');
      }).catch(function () { window.location.href = window.Shopify.routes.root + 'cart/add?id=' + id + '&quantity=1'; });
    });
  });
})();
